<template>
    <div ref="container" class='position-relative h-100'>

        <loading ref="loading"></loading>

        

        <slot name="head">
            
        </slot>

        <div class="card d-flex flex-column h-100">

            <header class="list-header" style="z-index: 100;">
                <h2 class="p-2">{{ title }}</h2>
            </header>

            <div ref="editScroller" class="card-body flex-grow-1-scroll">
                <local-error v-bind:errors='errors' v-bind:inline='inline_errors'></local-error>
                <slot name='body'>

                </slot>

            </div>

            <slot name='footer'>                
                <footer class='container-footer'>
                    <button v-if='item.id' class="btn btn-success btn-round " v-on:click.prevent='$emit("update")' role="button">{{ $t('translations.update')}}</button>
                    <button v-else class="btn btn-success btn-round " v-on:click.prevent='$emit("create")' role="button">{{ $t('translations.create')}}</button>

                    <button class="btn btn-warning btn-round" v-on:click.prevent='$emit("cancel")' role="button">{{ $t('translations.cancel')}}</button>
                    <button v-if='candelete' class="btn btn-danger btn-round  float-right" role="button" v-on:click.prevent='$emit("delete")'>{{ $t('translations.delete')}}</button>
                </footer>
            </slot>
        </div>
    </div>
</template>


<script>
	export default {
		props: {
			'route': {},
            'event': {},
			'model': {},
			'elementname': {},
            'type': 'edit',
            'item': {},
            'title': {default: "Edit"},
            'candelete': {default: false},
            'errors': {},
            'inline_errors': {
                default() {
                    return [];
                }
            },
		},
		
    }
</script>
